import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ProductsListQuery } from "../graphql/queries";
import type {
  ProductsListQueryType,
  ProductsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useProductsQuery = (
  options?: QueryHookOptions<
    ProductsListQueryType,
    ProductsListQueryVariablesType
  >
) => {
  return useQuery<ProductsListQueryType, ProductsListQueryVariablesType>(
    ProductsListQuery,
    options
  );
};
